import { For, Show } from "solid-js"
import { Menu } from "@opencode/ui/menu"
import { useLanguage } from "@/runtime/i18n/language"
import type { SidebarSort } from "./schema"
import { SidebarMenuPortal } from "./menu"

export function SidebarSortMenu(props: { mode: SidebarSort; onChange: (mode: SidebarSort) => void; nested?: boolean }) {
  const language = useLanguage()
  const options = ["manual", "attention", "updated"] as const
  const items = () => (
    <Menu.RadioGroup value={props.mode}>
      <For each={options}>
        {(mode) => (
          <Menu.RadioItem value={mode} closeOnSelect onSelect={() => props.onChange(mode)}>
            {language.t(`session.navigation.sort.${mode}`)}
          </Menu.RadioItem>
        )}
      </For>
    </Menu.RadioGroup>
  )
  return (
    <Show when={props.nested} fallback={items()}>
      <Menu.Sub>
        <Menu.SubTrigger>{language.t("session.navigation.sort")}</Menu.SubTrigger>
        <SidebarMenuPortal>
          <Menu.SubContent>{items()}</Menu.SubContent>
        </SidebarMenuPortal>
      </Menu.Sub>
    </Show>
  )
}
